(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('protocol', {
                parent: 'entity',
                url: '/protocol',
                data: {
                    authorities: [],
                    pageTitle: 'Protocols'
                },
                ncyBreadcrumb: {
                    label: 'Protocols'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/protocol/list/protocol.html',
                        controller: 'ProtocolController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_PATIENT_MEDICATION_TEMPLATE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_PATIENT_MEDICATION_TEMPLATE, access);
                }]
            })
    }
})();
